<div class="d-flex align-items-end justify-content-between">
  <div class="kt-searchbar mb-4">
    <div class="input-group flex-nowrap">
      <div class="input-group-prepend"><span class="input-group-text" id="basic-addon1">
          <svg-icon class="kt-font-brand svg_icon13x13" src="assets/media/iq-svg/without_circle/icon_set_3/search.svg"></svg-icon>
        </span>
      </div>
      <div>
        <kt-textbox type="text" class="form-control" [field]="formControls.search" [form]="form" placeholder="Search"
          aria-describedby="basic-addon1"></kt-textbox>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-end mb-4">
    <div class="filter-width ms-2">
      <kt-select [field]="formControls.clientIds" [form]="form" [options]="lookup.client"
        [values]="shiftDetail?.client?.client_id || []" (valueChange)="clientChange($event)">
      </kt-select>
    </div>
    <div class="filter-width ms-2">
      <kt-select [field]="formControls.locationIds" [form]="form" [options]="lookup.location"
        [values]="shiftDetail?.location?.location_id || []">
      </kt-select>
    </div>
    <div class="filter-width ms-2">
      <label for="">Added Date</label>
      <kt-date-range [field]="formControls.dateRange" [form]="form" [values]="{}" [dayLimit]="dayLimit"
        [readOnly]="true">
      </kt-date-range>
    </div>
    <div class="align-self-end ms-2">
      <button class="btn btn-brand secrch-btn" (click)="searchClick()">Search</button>
    </div>
  </div>
</div>
<ng-container *ngIf="handoverListData()">
  <kt-handover-notes-comments [_userId]="userId" [_handoverListData]="handoverListData()" [totalCount]="totalCount" [activeTab]="_activeTab"
    [_loading]="loading" (refresh)="refreshData()" (callback)="searchClick()" (scrollCallback)="scrolled()">
  </kt-handover-notes-comments>
</ng-container>
